import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';
import { getProject, totalNumOfFlowsForProject, getProjectFlows } from '../projects/getters';
import { allWorkflows, sharedWorkflows } from '../workflows/getters';
import { ALL_PROJECTS_VIRTUAL_ID, PROJECTS_SHARED_WITH_ME_VIRTUAL_ID, VIRTUAL_PROJECT_IDS } from '@/utils/projects.const';

const buildSelectedProjectGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

// getters declarations
export const selectedProjectId = buildSelectedProjectGetterObject('selectedProjectId');
export const selectedProject = buildSelectedProjectGetterObject('selectedProject');
export const shortenName = buildSelectedProjectGetterObject('shortenName');
export const selectedProjectFlows = buildSelectedProjectGetterObject('selectedProjectFlows');
export const loadingWorkflowsFlag = buildSelectedProjectGetterObject('loadingWorkflowsFlag');
export const totalNumOfFlows = buildSelectedProjectGetterObject('totalNumOfFlows');

const getters = {
	[selectedProjectId.getter]: (state) => state.selectedProjectId || ALL_PROJECTS_VIRTUAL_ID,
	[selectedProject.getter]: (state, getters, rootState, rootGetters) => rootGetters[getProject.fullPath](state.selectedProjectId),
	[shortenName.getter]: (state, getters) => {
		if (!getters[selectedProject.getter]) return '';
		const n = getters[selectedProject.getter].title.split(' ');
		var sh = '';
		// if name contains two words+ - take first letter of first two
		if (n && n.length > 1 && n[1].length >= 1) {
			sh = '' + n[0].substring(0, 1) + n[1].substring(0, 1).toLowerCase();
		}
		// or take first 2 letters of first word
		else {
			sh = '' + n[0].substring(0, 2).toLowerCase();
		}
		return sh;
	},
	[selectedProjectFlows.getter]: (state, getters, rootState, rootGetters) => {
		if (VIRTUAL_PROJECT_IDS.includes(state.selectedProjectId)) {
			if (PROJECTS_SHARED_WITH_ME_VIRTUAL_ID === state.selectedProjectId) {
				return rootGetters[sharedWorkflows.fullPath];
			}
			return rootGetters[allWorkflows.fullPath];
		}
		return rootGetters[getProjectFlows.fullPath](state.selectedProjectId);
	},
	[loadingWorkflowsFlag.getter]: (state) => state.loadingWorkflowsFlag,
	[totalNumOfFlows.getter]: (state, getters, rootState, rootGetters) =>
		rootGetters[totalNumOfFlowsForProject.fullPath](state.selectedProjectId),
};

export default getters;
